export default function Aurora() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 -z-10">
      <div className="absolute -top-40 -left-40 w-[60vw] h-[60vw] rounded-full blur-3xl opacity-20"
           style={{ background: "radial-gradient(closest-side, rgba(139,95,255,.6), transparent 70%)" }} />
      <div className="absolute -bottom-40 -right-40 w-[55vw] h-[55vw] rounded-full blur-3xl opacity-20"
           style={{ background: "radial-gradient(closest-side, rgba(217,70,239,.6), transparent 70%)" }} />
      <div className="absolute top-1/2 left-1/3 -translate-x-1/2 -translate-y-1/2 w-[40vw] h-[40vw] rounded-full blur-3xl opacity-15"
           style={{ background: "radial-gradient(closest-side, rgba(107,70,193,.55), transparent 70%)" }} />
    </div>
  );
}
